export default {"src":"/_next/static/media/benqi-lending.9624fe6f.svg","height":472,"width":472,"blurWidth":0,"blurHeight":0};